// 9fbef606107a605d69c0edbcd8029e5d
import { isAndroid } from '@tcp/core/src/utils';
import { createSelector } from 'reselect';
import { CHECKOUT_REDUCER_KEY } from '../../../../../constants/reducer.constants';

export const getAppleClientTokenData = (state) =>
  state[CHECKOUT_REDUCER_KEY].getIn(['values', 'appleClientTokenData']);

export const getAppleAppData = (state) =>
  state[CHECKOUT_REDUCER_KEY].getIn(['values', 'applePayAppData']);

export const isApplePaymentInProgress = (state) => {
  return state[CHECKOUT_REDUCER_KEY].getIn(['uiFlags', 'applePaymentInProgress']);
};

export function isAppleOrderPayment(state) {
  const orderConfirmation = state.Confirmation && state.Confirmation.get('orderConfirmation');
  const paymentLists = orderConfirmation && orderConfirmation.paymentsList;
  const applePayment =
    paymentLists && paymentLists.find((method) => method.paymentMethod.toLowerCase() === 'apple');
  return applePayment || false;
}

function isObj(data) {
  return data.constructor === {}.constructor;
}

export const getApplePayAppDataApp = createSelector(getAppleAppData, (appleAppData) => {
  const isApplePayEligible = isObj(appleAppData)
    ? appleAppData.isEligibleForApplePay
    : appleAppData.get('isEligibleForApplePay');
  const isLoading = isObj(appleAppData) ? appleAppData.loading : appleAppData.get('loading');

  return {
    loading: isLoading,
    isEligibleForApplePay: isAndroid() ? false : isApplePayEligible,
  };
});

export const getApplePayEligibleShippingState = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.APPLEPAY_ELIGIBLE_SHIPPING_STATES
  );
};
